import { Dispatch } from "react";

interface IForm {
  email: string | null;
  password: string | null;
}

const validateOnBlurEmail = async (
  form: IForm,
  setError: Dispatch<IForm>,
  errorStatus
) => {
  setError({ email: "", password: "" });
  if (form.email === "")
    return setError({
      ...errorStatus,
      email: "La dirección de correo electrónico es obligatoria",
    });

  if (form.password === "")
    return setError({
      ...errorStatus,
      password: "La contraseña es obligatoria",
    });

  const emailRegax = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (!emailRegax.test(form.email))
    return setError({
      ...errorStatus,
      email: "Ingresa una dirección de correo electrónico válida",
    });
};

export default validateOnBlurEmail;
